"use client";

import React from "react";
import Logo from "./logo";
import Link from "next/link";
import { Separator } from "@/components/ui/separator";
import { useGetHero } from "@/components/parts/admin/hero/api";
import { House, Package, UsersRound, Newspaper } from "lucide-react";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";
import HomeIcon from "@/assets/icons/homeIcon";
import NoteSolidIcon from "@/assets/icons/noteSolidIcon";
import PeopleIcon from "@/assets/icons/peopleIcon";
import NewsIcon from "@/assets/icons/newsIcon";

const navItems = [
  {
    href: "/",
    label: "Beranda",
    icon: (
      <div className="sm:hidden">
        <HomeIcon />
      </div>
    ),
  },
  {
    href: "/aspiration",
    label: "Usulan",
    icon: (
      <div className="sm:hidden">
        <NoteSolidIcon />
      </div>
    ),
  },
  {
    href: "/member",
    label: "Anggota",
    icon: (
      <div className="sm:hidden">
        <PeopleIcon />
      </div>
    ),
  },
  {
    href: "/news",
    label: "Berita",
    icon: (
      <div className="sm:hidden">
        <NewsIcon />
      </div>
    ),
  },
];

const LandingFooterSimple = () => {
  const { data } = useGetHero();
  const hero = data?.data;
  const pathname = usePathname();

  return (
    <footer className="bg-primary-700 text-white p-6">
      {/* Logo & Description */}
      <div className="flex flex-col md:flex-row md:items-center gap-4">
        <Logo className="w-16 h-16" />
        <p className="text-base md:text-lg">{hero?.description}</p>
      </div>

      <Separator className="bg-white my-4" />

      {/* Footer Bottom */}
      <div className="flex flex-row justify-between items-center text-sm relative">
        <p className="mb-20 sm:mb-0">
          &copy; SIMRESES {new Date().getFullYear()}
        </p>
        <ul className="flex gap-6 justify-between sm:justify-normal fixed sm:relative inset-x-0 sm:inset-auto bottom-0 z-20 bg-white sm:bg-transparent px-6 py-4 sm:py-0">
          {navItems.map((item) => {
            const isActive = pathname === item.href;
            return (
              <li key={item.href}>
                <Link
                  href={item.href}
                  className={cn(
                    "flex flex-col sm:flex-row items-center gap-1 sm:hover:text-gray-200",
                    {
                      "font-semibold text-primary-700 sm:text-white": isActive,
                      "text-gray-400": !isActive,
                    }
                  )}
                >
                  {item.icon}
                  <span>{item.label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </footer>
  );
};

export default LandingFooterSimple;
